import React from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import {
  isCurrentDay,
  isSelectedDay,
  getMonthDetails,
  onDateClick,
  uniqueId,
  isInsideRange,
  isFutureDate,
} from '../logic';
import makeStyles from './styles';

type Day = { month?: number; date?: number; timestamp?: number };
type datePickerProperties = {
  year: number;
  month: number;
  firstSelected?: number;
  setFirstSelected: Function;
  secondSelected?: number;
  setSecondSelected: Function;
  blockFutureDates?: boolean;
  startOrEndDate:boolean;
  setStartOrEndDate: Function;
};
const Calendar = ({
  year,
  month,
  firstSelected,
  setFirstSelected,
  secondSelected,
  setSecondSelected,
  blockFutureDates,
  startOrEndDate,
  setStartOrEndDate

}: datePickerProperties) => {
  const classes = makeStyles();

  const callBackFinder = (day: Day) => {
    if(day?.timestamp) {
      if(secondSelected && day.timestamp > secondSelected && startOrEndDate) return setSecondSelected
      if(firstSelected && day.timestamp < firstSelected && !startOrEndDate) return setFirstSelected
    }
    setStartOrEndDate(!startOrEndDate);
    if(startOrEndDate) {
      return setFirstSelected;
    }
    return setSecondSelected
  };

  const renderCalendar = () => {
    const days = getMonthDetails(year, month).map((day: Day, index: number) => (
      <Box
        key={uniqueId()}
        className={clsx(classes.dayContainer, {
          [classes.dayContainerDisabled]: blockFutureDates ? isFutureDate(day) : day.month !== 0,
          [classes.dayContainerToday]: isCurrentDay(day),
          [classes.dayContainerSelected]:
            isSelectedDay(day, firstSelected) || isSelectedDay(day, secondSelected),
          [classes.dayContainerBetweenSelection]: isInsideRange(
            day.timestamp,
            firstSelected,
            secondSelected,
          ),
        })}
      >
        <div
          className={classes.dayText}
          role="button"
          tabIndex={index}
          onKeyPress={() => onDateClick(day, callBackFinder(day))}
          onClick={() => onDateClick(day, callBackFinder(day))}
        >
          <span>{day.date}</span>
        </div>
      </Box>
    ));

    return (
      <Box>
        <Box className={classes.dayLabels}>
          {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map((d) => (
            <Box key={uniqueId()} className={classes.name}>
              {d}
            </Box>
          ))}
        </Box>
        <Box className={classes.daysBody}>{days}</Box>
      </Box>
    );
  };

  return (
    <Box className={classes.calendarContainer}>
      <Box className={classes.body}>{renderCalendar()}</Box>
    </Box>
  );
};

export default Calendar;
